<template>
<div class="list-button" >
        <!-- <b-button  v-b-toggle.sidebar-1 size="sm" variant="warning">list</b-button> -->
        <img v-b-toggle.sidebar-1 src=".././assets/map-locations-button.png">
        <!-- <b-icon v-b-toggle.sidebar-1 font-scale="4" icon="view-list"></b-icon> -->
        <b-sidebar  id="sidebar-1" title="Puncte de interes" right shadow>
            <div class="px-3 py-2" v-if="isfilteractive">
                <ul v-for="(p, pk) in poi"  :key="pk" >
                    <li href="#" @click="setCenter(p.lat, p.lng)"  class="flex-column align-items-start" v-show="p.ismarkervisible == true">
                        <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{p.nume}}</h5>
                        <small>{{p.tipaccesibil}}</small>
                        </div>
                        <p class="mb-1">
                        {{p.adresa}}
                        </p>
                        <small>{{p.lat}} {{p.lng}}</small>
                    </li>                
                </ul>
            </div>
            <div class="px-3 py-2" v-else>
                <p>Toate punctele de interes sunt pe harta, Va rugam folositi filtrele</p>
            </div>
         </b-sidebar>          
</div>
    
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: 'Filterlist',
    props: {
        poi: {type:Array},
        isfilteractive: {type: Boolean}
    },
    methods: {
        setCenter(lat,lng) {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
            let centerarray = {                
                'lat': Number(lat), 
                'lng': Number(lng)
            }
            this.$emit('setCenterForMarker', centerarray)
        },
        toggleSidebar(){
            this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
            this.$gtag.event('filter toggled', { method: 'Website' })
        }
    }
})
</script>

<style scoped>

    .b-sidebar-outer {       
        top:85px;
    }

    .b-sidebar-outer >>> .b-sidebar {       
        top:85px;
        width: 500px;
    }

    .list-button {
        z-index: 5;
        position: absolute;
        right: 10px;
        float: right;
        bottom: 15px;
    }
    ul.checkbox  { 
    margin: 0; 
    padding: 0; 
    margin-left: 20px; 
    list-style: none; 
    } 

    ul.checkbox li input { 
    margin-right: .25em; 
    }    


</style>